import React from 'react';

interface IconSupportProps {
    iconClasses?: string;
}

const IconSupport: React.FC<IconSupportProps> = ({ iconClasses }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-support ${iconClasses ?? ''}`}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.0543 0C19.2949 0 19.5258 0.0958179 19.6959 0.266363C19.8662 0.436908 19.9617 0.66818 19.9616 0.909331L19.9573 15.4708C19.9571 15.9728 19.5509 16.3796 19.0499 16.3796H15.4249C14.9238 16.3796 14.5176 15.9726 14.5176 15.4706V14.9961L9.18407 13.8817L10.3851 17.7274C10.5347 18.2065 10.2684 18.7164 9.79017 18.8664L6.30833 19.9584C6.2182 19.9867 6.12681 20.0002 6.0371 20.0002C5.65099 20.0002 5.29308 19.7513 5.17149 19.3627L3.05623 12.6011L0.722124 12.1134C0.301419 12.0254 0 11.654 0 11.2234V5.15617C0 4.72562 0.30148 4.35417 0.722124 4.26623L14.5176 1.38351V0.909088C14.5176 0.407029 14.9238 0 15.4249 0H19.0543ZM6.63189 17.9518L8.38234 17.4028L7.14986 13.4566L5.09104 13.0264L6.63189 17.9518ZM8.0364 11.7845L8.02787 11.7827L3.94077 10.9286L3.93448 10.9273L1.81463 10.4843V5.89514L14.5174 3.24072V13.1388L8.0364 11.7845ZM16.3324 14.5617H18.143L18.1467 1.81836H16.3324V2.12272V14.2573V14.5617Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconSupport;
